import { render, staticRenderFns } from "./ModalPolicy.vue?vue&type=template&id=2af1964c&scoped=true"
import script from "./ModalPolicy.vue?vue&type=script&lang=js"
export * from "./ModalPolicy.vue?vue&type=script&lang=js"
import style0 from "./ModalPolicy.vue?vue&type=style&index=0&id=2af1964c&prod&rel=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af1964c",
  null
  
)

export default component.exports